import React from "react";
import { Link } from "react-router-dom";
const hotels = [
  { name: "Malkajgiri", mapLink: "https://goo.gl/maps/example1", phone: "tel:+919876543210" },
  { name: "Dr AS Rao Nagar", mapLink: "https://goo.gl/maps/example2", phone: "tel:+919876543211" },
  { name: "Jillelaguda", mapLink: "https://goo.gl/maps/example3", phone: "tel:+919876543212" },
  { name: "Miryalaguda", mapLink: "https://goo.gl/maps/example4", phone: "tel:+919876543213" },
];

const HotelCards = () => {
  return (
    <div style={styles.container}>
      {hotels.map((hotel, index) => (
        <div style={styles.card} key={index}>
          <h2 style={styles.title}>Hotel Swagath Grand</h2>
          <p style={styles.location}>{hotel.name}</p>
          <div style={styles.icons}>
            <a href={hotel.phone} style={{ ...styles.icon, ...styles.call }}>
              📞
            </a>
            <a 
  href="https://lh3.googleusercontent.com/gps-cs-s/AB5caB-qOJgF4EttpGjMskv0eSTuZbkgOCOefJh8KpOnl-1-abJoRBeljjQiwzkjoxxdSUkeWjjdJTnuEKp-HQrTt0g0r_DCPzB-enbB9BRfkGpYRGEmUX6EQV0Y8w8xkzxYNoXclA3eBw=w408-h306-k-no" 
  target="_blank" 
  rel="noopener noreferrer" 
  style={{ ...styles.icon, ...styles.middle }}
>
  360°
</a>
<a 
  href={`https://www.google.com/maps?q=${encodeURIComponent(hotel.location)}`} 
  target="_blank" 
  rel="noopener noreferrer" 
  style={{ ...styles.icon, ...styles.map }}
>
  📍
</a>

          </div>
          <Link to="/what-we-do" style={{ color: "green", textDecoration: "none", fontWeight: "bold" }}>
      VIEW DETAILS
    </Link>
        </div>
      ))}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    justifyContent: "center",
   
    minHeight: "50vh",
    alignItems: "center",
    padding: "20px",
  },
  card: {
    background: "white",
    padding: "20px",
    borderRadius: "20px",
    width: "250px",
    textAlign: "center",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    transition: "transform 0.3s",
  },
  title: {
    fontSize: "18px",
    color: "#0a1f44",
  },
  location: {
    fontSize: "16px",
    color: "#d39c43",
    fontWeight: "bold",
    margin: "5px 0 15px",
  },
  icons: {
    display: "flex",
    justifyContent: "center",
    gap: "15px",
    marginBottom: "15px",
    color:'green'
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    background: "#f5d7a1",
    borderRadius: "50%",
    fontSize: "18px",
    cursor: "pointer",
    textDecoration: "none",
    color: "black",
  },
  middle: {
    background: "#7d92ac",
    color: "white",
  },
  call: {
    background: "#28a745",
    color: "white",
  },
  map: {
    background: "#007bff",
    color: "white",
  },
  viewDetails: {
    color: "#003366",
    fontSize: "14px",
    textDecoration: "none",
    fontWeight: "bold",
  },
};

export default HotelCards;
